import { PlaceholderScreen } from "@/shell/PlaceholderScreen";
import { CartIcon } from "@/ui/icons/CartIcon";

export default function Cart() {
  return (
    <PlaceholderScreen
      title="Cart"
      testID="placeholder-cart"
      Icon={CartIcon}
      tile="tileAmber"
      ink="onTileAmber"
      homeLink
    />
  );
}
